import React, { useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LayerCombo from './LayerCombo';
import RegularButton from 'components/CustomButtons/Button';
import useLayerContext from 'contexts/layerContext';
import { Add, Remove } from '@material-ui/icons';

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  );
}

function LayerDivitionTab(props) {
  const { disabled = false, customerRoutes, onCustomerRouteChange } = props;
  const { onAddDivition } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [addressDivitions, setAddressDivitions] = useState([]);

  const {
    divitions,
    selectedDivition,
    selectedLayer,
    setSelectedDivition,
    setSelectedLayer,
    excludedDivitions,
    setExcludedDivitions,
  } = useLayerContext();

  async function addDivition() {
    if (addressDivitions.map((ad) => ad.divition.id).includes(selectedDivition.id)) {
      return;
    }
    if (selectedLayer === undefined) return;
    if (onAddDivition !== undefined) {
      try {
        await onAddDivition(selectedDivition, selectedLayer);
      } catch {
        return;
      }
    }

    let newDivitions = [...addressDivitions];
    newDivitions.push({
      divition: selectedDivition,
      layer: selectedLayer,
    });

    setAddressDivitions(newDivitions);
    setExcludedDivitions((excluded) => {
      let newExcluded = [...excluded];
      newExcluded.push(selectedDivition.id);
      return newExcluded;
    });

    setTimeout(() => {
      setSelectedDivition(newDivitions[newDivitions.length - 1].divition);
      setSelectedLayer(newDivitions[newDivitions.length - 1].layer);
      setSelectedIndex(newDivitions.length - 1);
    });
  }

  // function removeDivition(addressDivition) {
  //   if (!addressDivitions.map((ad) => ad.divition.id).includes(selectedDivition.id)) {
  //     return;
  //   }

  //   let newDivitions = [...addressDivitions];
  //   let index = newDivitions.findIndex((ad) => ad.divition.id === addressDivition.divition.id);
  //   newDivitions.splice(index, 1);

  //   setAddressDivitions(newDivitions);
  //   setExcludedDivitions((excluded) => {
  //     let newExcluded = [...excluded];
  //     let index = newExcluded.findIndex((divitionId) => divitionId === addressDivition.divition.id);
  //     newExcluded.splice(index, 1);
  //     return newExcluded;
  //   });
  //   if (newDivitions.length > 0) {
  //     setTimeout(() => {
  //       setSelectedDivition(newDivitions[0].divition);
  //       setSelectedLayer(newDivitions[0].layer);
  //       setSelectedIndex(0);
  //     });
  //   }
  // }

  function selectIndex(_, index) {
    // Nueva divición
    if (addressDivitions.length === index) {
      if (onCustomerRouteChange !== undefined && customerRoutes !== undefined) {
        onCustomerRouteChange(undefined);
      }
      setSelectedIndex(index);
      let divition = divitions.find((divition) => !excludedDivitions.includes(divition.id));
      setSelectedDivition(divition);
      // TODO Setear divición que no este en la lista
      return;
    }

    // Capa ya existente
    setSelectedDivition(addressDivitions[index].divition);
    setSelectedIndex(index);
    if (onCustomerRouteChange !== undefined && customerRoutes !== undefined) {
      let cr = customerRoutes.find((cr) => cr.divition.id === addressDivitions[index].divition.id);
      onCustomerRouteChange(cr);
      setTimeout(() => {
        setSelectedLayer(cr.route.layer);
      });
    }else{
      setSelectedLayer(addressDivitions[index].layer);
    }
  }

  // AL cambiar el listado de ClienteRuta
  useEffect(() => {
    if (customerRoutes === undefined || customerRoutes.length === 0) return;
    
    let addressDivitions = customerRoutes
      .filter((cr) => cr.route !== null)
      .map((cr) => ({
        divition: cr.divition,
        layer: cr.route.layer,
      }));
    let excluded = customerRoutes
      .filter((cr) => cr.route !== null)
      .map((cr) => cr.divition.id);

    setAddressDivitions(addressDivitions);
    setExcludedDivitions(excluded);
  }, [customerRoutes]);

  return (
    <div>
      <AppBar position="static">
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Tabs value={selectedIndex} onChange={selectIndex}>
              {addressDivitions.map((addressDivition) => {
                return (
                  <Tab
                    label={addressDivition.divition.name}
                    key={addressDivition.divition.id}
                    disabled={disabled}
                  />
                );
              })}
              {divitions.length !== addressDivitions.length && <Tab label="Nueva divición" />}
            </Tabs>
          </div>
          {divitions.length !== addressDivitions.length && (
            <RegularButton
              justIcon
              color="success"
              onClick={addDivition}
              disabled={
                disabled ||
                (selectedIndex !== addressDivitions.length &&
                  (selectedDivition === undefined || selectedLayer === undefined))
              }
            >
              <Add />
            </RegularButton>
          )}
        </div>
      </AppBar>
      {addressDivitions.map((ad, index) => {
        return (
          <TabPanel value={selectedIndex} index={index} key={ad.divition.id}>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <LayerCombo
                  ignoreExcluded
                  lockDivition
                  disabled={disabled}
                  onChange={(_, item) => {
                    setAddressDivitions((addressDivitions) => {
                      let newDivitions = [...addressDivitions];
                      let index = newDivitions.findIndex((ad) => ad.divition.id === ad.divition.id);
                      if (index === -1) return addressDivitions;
                      newDivitions[index].layer = item;
                      return newDivitions;
                    });
                  }}
                />
              </div>
              {/* <RegularButton justIcon round color="danger" onClick={() => removeDivition(ad)}>
                <Remove />
              </RegularButton> */}
            </div>
          </TabPanel>
        );
      })}

      {divitions.length !== addressDivitions.length && (
        <TabPanel value={selectedIndex} index={addressDivitions.length} key={'ad'}>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <LayerCombo disabled={disabled} />
            </div>
          </div>
        </TabPanel>
      )}
    </div>
  );
}

export default LayerDivitionTab;
